import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownLeftSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 9.224-.094 6.682m0 0L9.224 16m6.682-.094L8 8"
    />
  </svg>
);
export default SvgArrowDownLeftSm;
